/**
 * State of timing field
 */
export enum TimingStatus {
	Custom = 1,
	Template,
	NoRestriction,
}
